export const NOTICE_APP_PATH = '/notice'
export const NOTICE_PUBLIC_PATH = '/notice/info'
